<template>
    <router-view v-if="!loading" />
    <div class="row" v-else>
        <MoonLoader color="#00AEEF" size="70px" class="loader mx-auto mt-5 mb-4" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import loader from '@/helpers/loader';
    import MoonLoader from 'vue-spinner/src/MoonLoader';

    export default {
        components: {
            MoonLoader,
        },

        async created() {
            loader.multiLanguage = this.$ml;
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            ...mapGetters({
                selectedCard: 'dataOnFile/getSelectedCard',
            }),
        },
    };
</script>

<style lang="scss" scoped>
    .loader {
        display: block;
        width: 70px;
        height: 70px;
    }
</style>
